import { Navigate } from "react-router";
import { firstAllowedPath } from "@/lib/navigationPath";
import { useAuthStore } from "@/store/authStore";
import { Permission } from "@/types";

const PAYMENTS_LANDING = [
  { permission: Permission.ECONOMIC_EVENTS_LIST, path: "events" },
  {
    permission: Permission.EXTERNAL_PAYMENTS_LIST,
    path: "external-payments",
  },
  { permission: Permission.SETTLEMENTS_LIST, path: "settlements" },
] as const;

export default function AdminPaymentsIndexRoute() {
  const hasPermission = useAuthStore((s) => s.hasPermission);
  return (
    <Navigate
      to={firstAllowedPath(hasPermission, PAYMENTS_LANDING)}
      replace
    />
  );
}
